import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row } from 'react-flexbox-grid';
import { intlShape, injectIntl } from 'react-intl';

import AlertDialog from 'components/AlertDialog';
import { actions } from 'store/newDocumentStore';

import IconButton from 'material-ui/IconButton';
import Delete from 'material-ui/svg-icons/action/delete';

import { iconArea } from './DeleteHandler.less';

import { docDeleteStaticReason } from '../../../project.config.js';

class DeleteHandler extends React.Component {
  state = {
    dialogOpen: false,
  };

  handleOpenClose = () => {
    this.setState({ dialogOpen: !this.state.dialogOpen });
  };

  handleClick = () => {
    this.handleOpenClose();
  };

  handleCancel = () => {
    this.handleOpenClose();
  };

  // TODO (NEUR-3656): a new commit is created as a consequence of this action for whatever reason -- prevent that!
  handleDelete = () => {
    const { documentType, documentId, dispatch } = this.props;
    const deleteReason = { reason: { reason: docDeleteStaticReason }, date: Date.now() };

    // Remove document from database (via server) and redux state
    dispatch(actions.deleteDocument(documentType, documentId, deleteReason));
    this.handleOpenClose();
    setTimeout(() => {
      window.location.href = '/documents/' + documentType;
    }, 300);
  };

  render() {
    const {
      color,
      documentType,
      intl: { formatMessage },
    } = this.props;
    return (
      // "Piggybag" alertdialog with buttonarea, newer React would support exporting separate elements
      <Row middle="xs" className={iconArea}>
        <AlertDialog
          visible={this.state.dialogOpen}
          alertMessage={documentType + '.remove.warningText'}
          cancelButtonText="remove.cancel"
          acceptButtonText="remove.accept"
          cancelButtonStyle={{ button: 'raised', primary: true }}
          acceptButtonStyle={{ button: 'flat', primary: true }}
          onCancel={this.handleCancel}
          onAccept={this.handleDelete}
          formatMessage={formatMessage}
        />
        <IconButton style={{ padding: '0', height: 'auto' }} iconStyle={{ color: color || 'white' }}>
          <Delete onClick={this.handleClick} />
        </IconButton>
      </Row>
    );
  }
}

DeleteHandler.propTypes = {
  color: PropTypes.string,
  documentType: PropTypes.string.isRequired,
  documentId: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  intl: intlShape,
};

export default injectIntl(connect()(DeleteHandler));
